"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.popoverConfig = exports.intialValuesConfig = exports.industrySectorROAPercent = exports.industryMap = exports.idPrefix = exports.dropdownOptions = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'keyemployee';
var idPrefix = exports.idPrefix = "ke_";
var dropdownOptions = exports.dropdownOptions = {
  industrySectorArray: ['Agriculture', 'Arts & Entertainment', 'Construction', 'Educational Services', 'Energy', 'Environmental Services', 'Financial Services', 'Health Care', 'Manufacturing', 'Personal Services', 'Professional Services', 'Retail Trade', 'Real Estate', 'Technology', 'Transportation', 'Utilities', 'Wholesale Trade']
};

// Return on Assets Percentages are based on Q2 - 2022 CSI Market numbers
var industrySectorROAPercent = exports.industrySectorROAPercent = {
  agricultureROA: 0.2006,
  artsAndEntertainmentROA: 0.0324,
  constructionROA: 0.1168,
  educationalServicesROA: 0.0578,
  energyROA: 0.1105,
  environmentalServicesROA: 0.0567,
  financialServicesROA: 0.0571,
  healthCareROA: 0.0392,
  manufacturingROA: 0.0703,
  personalServicesROA: 0.0666,
  professionalServicesROA: 0.1485,
  retailTradeROA: 0.0638,
  realEstateROA: 0.0381,
  technologyROA: 0.0737,
  transportationROA: 0.0618,
  utilitiesROA: 0.0265,
  wholesaleTradeROA: 0.0927
};
var industryMap = exports.industryMap = {
  Agriculture: 'agricultureROA',
  'Arts & Entertainment': 'artsAndEntertainmentROA',
  Construction: 'constructionROA',
  'Educational Services': 'educationalServicesROA',
  Energy: 'energyROA',
  'Environmental Services': 'environmentalServicesROA',
  'Financial Services': 'financialServicesROA',
  'Health Care': 'healthCareROA',
  Manufacturing: 'manufacturingROA',
  'Personal Services': 'personalServicesROA',
  'Professional Services': 'professionalServicesROA',
  'Retail Trade': 'retailTradeROA',
  'Real Estate': 'realEstateROA',
  Technology: 'technologyROA',
  Transportation: 'transportationROA',
  Utilities: 'utilitiesROA',
  'Wholesale Trade': 'wholesaleTradeROA'
};
var popoverConfig = exports.popoverConfig = {
  keyEmployeeText: "A key employee is one that has ownership and/or plays a critical role in your company, but isn't necessarily part of your management team. Key employees are often vital to your everyday business and difficult to replace, thanks to their unique skills, relationships, and overall experience. Your key employees have a direct impact on your bottom line.",
  industrySectorText: "We use industry categories to determine your business's return on assets (ROA), using the average ROA for your industry. This helps us figure out the portion of your profits that can be attributed to key employees.",
  aveGrossProfitText: "To determine the approximate average gross profit, subtract either the cost of goods sold, or your selling, general, and administrative expenses (SG&A) from your business revenue over the past 3 years. 'Cost of goods sold' refers to the direct costs attributable to the production of the goods sold by a company. SG&A is the sum of all direct and indirect selling expenses and all general and administrative expenses of a company.",
  shortTermAssetsText: 'Short-term assets include cash, accounts receivable, inventory, and investments. They do not include fixed assets, such as property or equipment, or intangibles, such as goodwill. We focus on short-term assets because this is the area key employees are more likely to influence.',
  roaInfoText: 'Return on assets (ROA) is an indicator of how profitable a company is relative to its total assets. It shows how efficient your key employees are at using assets to generate earnings. ROA is calculated by dividing a company’s annual earnings by it’s total assets. For the purposes of our calculator, we used the average ROA within your industry sector. We derived our numbers using data from CSIMarket, Q2 2022.',
  estimatedProfitText: 'This is the amount of profit your key employees generate. We calculated this by multiplying your business assets by the industry ROA percentage, then subtracting that result from your business’s average profit over the past 3 years.',
  annualProfitAttributableText: 'This is an estimate of the portion of your profits that can be attributed to this employee. Some common ways key employees contribute to profits are sales, efficiency, intellectual capital, relationships, and leadership.',
  replaceEmployeeYearsText: 'This is an estimate of how many years it would take to fully replace this employee. This is more than just the time it would take to find and hire someone else. It also includes the time it would take until your new hire can contribute to the same degree the previous employee in that position did.'
};
var propsConfig = exports.propsConfig = {
  config: {
    Icon: 'icon-handshake-black',
    Label: 'Key Employee Value',
    HasBorder: true,
    Steps: [{
      Title: 'The Value of Key Employees',
      Description: '',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'My Business',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: '',
        Side: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Key Employee Profits',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Your Results',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Edit your inputs & our assumptions',
        Icon: '',
        Variant: 'secondary',
        Side: 'L'
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: 'Next step',
        Description: 'Discuss your results with a financial professional today.',
        CTAList: [{
          Label: 'Contact a Financial Professional',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }]
  }
};
var validationConfigPage1 = yup.object().shape({
  industrySector: yup.string().required('Please select one of the options').oneOf(dropdownOptions.industrySectorArray)
});
var validationConfigPage2 = yup.object().shape({
  aveGrossProfitPrior3YearsAmount: yup.number().transform(_utils.parseCurrencyString).required('Please enter a number between $0 and $100,000,000').min(0, 'Must be between $0 and $100,000,000').max(100000000, 'Must be between $0 and $100,000,000'),
  shortTermAssetsEstimates: yup.number().transform(_utils.parseCurrencyString).required('Please enter a number between $0 and $100,000,000').min(0, 'Must be between $0 and $100,000,000').max(100000000, 'Must be between $0 and $100,000,000')
});
var validationConfigPage3 = yup.object().shape({
  employees: yup.array().of(yup.object().shape({
    employeeId: yup.string().max(200, 'Must be less than 200 characters').required('Must enter a name').matches(/^[^$&+,:;=?@#|'<>.^*()%!"]([A-Za-z]| |'|-)+$/, 'Only alphabets are allowed for this field '),
    annualProfitAttributable: yup.number().transform(parseFloat).required('Please enter a percentage between 0% and 100%').min(0, 'Please enter a percentage between 0% and 100%').max(100, 'Please enter a percentage between 0% and 100%'),
    replaceEmployeeYears: yup.number().transform(parseFloat).required('Please enter a number between 0 and 10').min(0, 'Please enter a number between 0 and 10').max(10, 'Please enter a number between 0 and 10')
  })).required('Must have employees')
});
var validationModal = validationConfigPage1.concat(validationConfigPage2).concat(validationConfigPage3);
var validationConfig = exports.validationConfig = [validationConfigPage1, validationConfigPage2, validationConfigPage3, validationModal];
var intialValuesConfig = exports.intialValuesConfig = {
  industrySector: '',
  aveGrossProfitPrior3YearsAmount: '',
  shortTermAssetsEstimates: '',
  employees: [{
    employeeId: ''
  }]
};